export const convertSecToMin = (s) => {
    s = Math.floor(s); 
    const minutes = Math.floor(s / 60);
    const seconds = s % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
}


